import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PrivateCheckInOutIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PrivateCheckInOutIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.1773 2.13574C16.9551 2.13574 15.9609 3.12988 15.9609 4.35254C15.9609 5.57422 16.9551 6.56836 18.1773 6.56836C19.3989 6.56836 20.3931 5.57422 20.3931 4.35254C20.3931 3.12988 19.3989 2.13574 18.1773 2.13574ZM18.1773 5.25781C17.6777 5.25781 17.2715 4.85156 17.2715 4.35254C17.2715 3.85352 17.6777 3.44727 18.1773 3.44727C18.6763 3.44727 19.0825 3.85352 19.0825 4.35254C19.0825 4.85156 18.6763 5.25781 18.1773 5.25781Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M13.4946 20.5537H3.53664V14.6455H11.9341C12.2954 14.6455 12.5894 14.3516 12.5894 13.9902C12.5894 13.6289 12.2954 13.335 11.9341 13.335H4.94142V9.97169C4.94142 9.47267 5.34767 9.06642 5.84669 9.06642H8.96827C9.46729 9.06642 9.87354 9.47267 9.87354 9.97169V10.8692C9.87354 11.2305 10.1675 11.5244 10.5293 11.5244C10.8906 11.5244 11.1846 11.2305 11.1846 10.8692V9.97169C11.1846 8.74903 10.1904 7.75489 8.96826 7.75489H5.84668C4.62451 7.75489 3.63037 8.74903 3.63037 9.97169V13.335H2.88135C2.51953 13.335 2.22559 13.6289 2.22559 13.9902V21.8643H13.4946C13.856 21.8643 14.1499 21.5703 14.1499 21.209C14.1499 20.8477 13.856 20.5537 13.4946 20.5537Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.60256 2.1748C6.38039 2.1748 5.38625 3.16894 5.38625 4.3916C5.38625 5.61328 6.38039 6.60742 7.60256 6.60742C8.82473 6.60742 9.81887 5.61328 9.81887 4.3916C9.81887 3.16894 8.82473 2.1748 7.60256 2.1748ZM7.60256 5.29687C7.10354 5.29687 6.69729 4.89062 6.69729 4.3916C6.69729 3.89258 7.10354 3.48633 7.60256 3.48633C8.10158 3.48633 8.50783 3.89258 8.50783 4.3916C8.50783 4.89062 8.10158 5.29687 7.60256 5.29687Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.7378 21.8643C20.0991 21.8643 20.3931 21.5703 20.3931 21.209V16.1494L20.4761 16.1192C21.3604 15.8057 21.9541 14.9658 21.9541 14.0293V9.77638C21.9541 8.55372 20.96 7.55958 19.7378 7.55958H16.6162C15.3941 7.55958 14.3999 8.55372 14.3999 9.77638V14.0293C14.3999 14.9658 14.9937 15.8057 15.8779 16.1192L15.961 16.1494V21.209C15.961 21.5703 16.2549 21.8643 16.6162 21.8643C16.9775 21.8643 17.2715 21.5703 17.2715 21.209V15.5899C17.2715 15.2285 16.9775 14.9346 16.6162 14.9346C16.1172 14.9346 15.711 14.5283 15.711 14.0293V9.77638C15.711 9.27736 16.1172 8.87111 16.6162 8.87111H19.7378C20.2368 8.87111 20.6431 9.27736 20.6431 9.77638V14.0293C20.6431 14.5283 20.2368 14.9346 19.7378 14.9346C19.3765 14.9346 19.0825 15.2285 19.0825 15.5899V21.209C19.0825 21.5703 19.3765 21.8643 19.7378 21.8643Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PrivateCheckInOutIcon;
